'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TRANSLATIONS_QUERY = 'translations:query';
var TRANSLATIONS_LOADED = 'translations:loaded';

exports.TRANSLATIONS_LOADED = TRANSLATIONS_LOADED;
exports.TRANSLATIONS_QUERY = TRANSLATIONS_QUERY;
